(function() {
    'use strict';

    angular.module('user')
        .controller('AdminBarcodeController', AdminBarcodeController);

    AdminBarcodeController.$inject = ['$state', 'adminDataSrvc'];

    function AdminBarcodeController($state, adminDataSrvc) {
        var self = this;

        self.barcode = null;
        self.fullName = null;

        activate();

        function activate() {
            getBarcode()
        }

        function getBarcode() {
            adminDataSrvc.barcode({
                pk: $state.params.pk
            }).$promise.then(
                function (response) {
                    self.barcode = response.barcode;
                    self.fullName = response.fullName;
                }
            );
        }
    }
})();
